import { render, staticRenderFns } from "./SelectDeptUser.vue?vue&type=template&id=63dfff4e&scoped=true"
import script from "./SelectDeptUser.vue?vue&type=script&lang=js"
export * from "./SelectDeptUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfff4e",
  null
  
)

export default component.exports